const BankSheba = () =>
  import(
    /* webpackChunkName: "bank-sheba" */ "@/components/AccountPage/Banking/BankingSheba/BankSheba"
  );

import { BankService } from "@/services";

import $enDigits from "@/mixins/enDigits";

export default {
  name: "banking-sheba",
  components: { BankSheba },
  mixins: [$enDigits],
  data() {
    return {
      title: "",
      sheba: "",
      shebaList: [],
      shebaModal: false,
      isCardHover: false,
      isCardFocus: false,
      isRequesting: false,
      errorText: "",
      shebaRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.bankInformation.shebaCards.modals.addCards.emptyShebaInputCard"
          ),
        v =>
          /^(?:IR)(?=.{24}$)[0-9]*$/.test(v) ||
          this.$t(
            "accountPage.bankInformation.shebaCards.modals.addCards.invalidShebaInputCard"
          )
      ]
    };
  },
  computed: {
    emailNameClass() {
      if (this.isCardFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isShebaValid) {
          return "mobile_name_error";
        } else {
          if (this.sheba) {
            return "mobile_name_fill";
          } else {
            if (this.isCardHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },

    isShebaValid() {
      if (this.sheba) {
        const shebaRegex = /^(?:IR)(?=.{24}$)[0-9]*$/;
        return shebaRegex.test(this.sheba);
      }
      return true;
    }
  },
  mounted() {
    !this.shebaList.length &&
      BankService.getSheba().then(res => {
        this.shebaList = res.data.data;
      });
  },
  methods: {
    checkValidation() {
      this.errorText = "";
      if (this.sheba) {
        if (this.isShebaValid) {
          if (!this.title) {
            this.errorText = this.$t(
              "accountPage.bankInformation.shebaCards.modals.addCards.emptyTitleInputCard"
            );
          }
        } else {
          this.errorText = this.$t(
            "accountPage.bankInformation.shebaCards.modals.addCards.invalidShebaInputCard"
          );
        }
      } else {
        this.errorText = this.$t(
          "accountPage.bankInformation.shebaCards.modals.addCards.emptyShebaInputCard"
        );
      }
    },

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openShebaModal() {
      this.shebaModal = true;
    },

    closeShebaModal() {
      this.shebaModal = false;
    },

    addSheba() {
      this.checkValidation();
      if (this.title && this.sheba) {
        BankService.addSheba(this.sheba, this.title)
          .then(res => {
            this.closeShebaModal();
            this.shebaList.push(res.data.data);
            this.$toast.success(res.data.message);
            this.sheba = "";
            this.title = "";
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    deleteSheba(shebaId) {
      this.shebaList = this.shebaList.filter(sheba => sheba.id !== shebaId);
    },

    setCardHover(bool) {
      this.isCardHover = bool;
    },

    toggleCardFocus() {
      this.isCardFocus = !this.isCardFocus;
    }
  },
  watch: {
    sheba(value) {
      this.checkValidation();
      if (value) {
        this.sheba = this.$enDigits(value.toUpperCase());
      }
    },

    title() {
      this.checkValidation();
    }
  }
};
